import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { currentAccountSelector, currentUserSelector } from '../selectors/AuthSelector';
import * as FinesActions from '../actions/FinesActions';
import * as BorrowingActions from '../actions/BorrowingActions';
import MessagingActions from '../actions/MessagingActions';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

import BasePageContainer from './BasePageContainer';

import Immutable from 'immutable';
import Fines from '../components/borrowing/fines/Fines';
import { getSummary } from '../selectors/BorrowingSelector';
import { getFines } from '../selectors/FinesSelector';
import DocumentHeadContainer from './DocumentHeadContainer';

export class FinesContainer extends BasePageContainer {

  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(BorrowingActions.fetchSummaries({ accountId })),
      store.dispatch(FinesActions.fetchFines({
        ...query,
        accountId
      }))
    ];
  }

  static getBackToTitleKey() {
    return 'fines';
  }

  componentDidMount() {
    super.componentDidMount();

    const { accountId, location } = this.props;
    this.props.FinesActions.fetchFines({ ...location.query, accountId });
  }

  finesIDList() {
    return this.props.fines.map((fine) => {
      const fineId = fine.get('id');
      return fineId;
    }).toList();
  }

  render() {
    const pageTitle = this.props.intl.formatMessage({ id: 'section_title_fines' });
    return (
      <div>
        <DocumentHeadContainer pageTitle={pageTitle} />
        <Fines finesIDs={this.finesIDList()} {...this.props} />
      </div>
    );
  }
}


const mapDispatchToProps = dispatch => ({
  FinesActions: bindActionCreators(FinesActions, dispatch),
  messagingActions: bindActionCreators(MessagingActions, dispatch)
});

const mapStateToProps = (state, ownProps) => {
  const user = currentUserSelector(state);
  const library = currentLibrarySelector(state);
  const onlineFinesPayment = library.get('onlineFinePayment', Immutable.Map());
  const account = currentAccountSelector(state);
  const accountId = currentAccountSelector(state).get('id').toString();
  const fines = getFines(state);
  const paymentForm = state.getIn(['borrowing', 'fines', 'paymentForm', 'html']);
  const totalItems = state.getIn(['borrowing', 'fines', accountId, 'page', 'totalElements']);
  const totalPages = state.getIn(['borrowing', 'fines', accountId, 'page', 'totalPages']);
  const pageSize = state.getIn(['borrowing', 'fines', accountId, 'page', 'size']);
  const currentPage = parseInt(ownProps.location.query.page || '1', 10);
  const summary = getSummary(state, 'fines');
  const isFetching = state.getIn(['borrowing', 'fines', 'isFetching']);
  return {
    user,
    account,
    fines,
    summary,
    paymentForm,
    totalItems,
    totalPages,
    pageSize,
    currentPage,
    isFetching,
    onlineFinesPayment,
    accountId
  };
};

FinesContainer.propTypes = {
  intl: intlShape,
  accountId: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(FinesContainer));



// WEBPACK FOOTER //
// ./app/containers/FinesContainer.jsx